import { numberWithSeparator } from '@/utils/format-strings'

export default {
  name: 'CurrencyFormatInput',

  props: {
    value: {
      type: Number
    },
    placeholder: {
      type: String,
      default: ''
    },
    error: {
      type: Boolean,
      default: false
    },
    isFormControl: {
      type: Boolean,
      default: true
    },
    styleInput: {
      type: Object
    }
  },
  data: function() {
    return {
      isInputActive: false
    }
  },
  computed: {
    displayValue: {
      get: function() {
        if (this.isInputActive) {
          return this.value.toString()
        } else {
          if (this.value || this.value === 0) {
            return `${numberWithSeparator(this.value)} ₽`
          }
          return ''
        }
      },
      set: function(modifiedValue) {
        if (this.testLastSymbol(modifiedValue)) {
          let newValue = modifiedValue
          if (newValue !== '-') {
            newValue = parseInt(newValue.replace(/[^0-9-]+/g, ''))
            if (isNaN(newValue)) {
                newValue = 0
            }
            this.$refs['input'].value = newValue
            this.$emit('input', newValue)
          } else {
            this.$emit('input', 0)
            this.$nextTick(() => {
              /**
               * При blur все равно произойдет перерисовка,
               * так как будет новое значение isInputActive
               * и значение если не будет изменено станет 0
               */
              this.$refs['input'].value = '-'
            })
          }
          
        }
      }
    }
  },
  methods: {
    testLastSymbol(str) {
      const lastSymbol= str[str.length - 1]
      return /[0-9-]/.test(lastSymbol)
    },
    onInput(e) {
      const value = e.target.value
      if (!this.testLastSymbol(value)) {
        e.target.value = value.slice(0, value.length - 1)
      }
    },
    onFocus() {
      this.isInputActive = true
      this.$emit('focus')
    },
    onBlur() {
      this.isInputActive = false
      this.$emit('blur')
    }
  }
}
